
<template>
    <section>
        <div class="max-w-[80rem] mx-auto px-4 sm:px-6 md:px-8">
            <slot></slot>
        </div>
    </section>
</template>

